import React, { SVGProps } from "react"

const FavoritesIcon: React.FC<SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "20"}
      height={props.height || "20"}
      viewBox="0 0 20 20"
      className={"stroke-fg-1"}
      {...props}>
      <path
        d="M3.59835 5.26485C2.13388 6.72932 2.13388 9.10369 3.59835 10.5682L10 16.9698L16.4017 10.5682C17.8661 9.10369 17.8661 6.72932 16.4016 5.26485C14.9372 3.80039 12.5628 3.80039 11.0983 5.26485L10 6.36325L8.90165 5.26485C7.43718 3.80039 5.06282 3.80039 3.59835 5.26485Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default FavoritesIcon
